import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

export default function Addresses() {
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    'admin:addresses:filters',
    {},
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: 'name',
      field: 'name',
    },
    {
      desc: 'address',
      field: 'address',
    },
    {
      desc: 'address_name',
      field: 'address_name',
    },
    {
      desc: 'user',
      field: 'user',
    },
    {
      desc: '更新日期',
      field: 'update_time',
    },
  ]

  const filterUI = (
    <div className="flex gap-2">
      <Input
        placeholder="名字"
        className="w-[150px]"
        value={filters.address_name || ''}
        onChange={(e) => {
          const newFilters = { ...filters }
          if (e.target.value) {
            newFilters.address_name = e.target.value
          } else {
            delete newFilters.address_name
          }
          setFilter(newFilters)
        }}
      />
      <Input
        placeholder="地址"
        className="w-[150px]"
        value={filters.address || ''}
        onChange={(e) => {
          const newFilters = { ...filters }
          if (e.target.value) {
            newFilters.address = e.target.value
          } else {
            delete newFilters.address
          }
          setFilter(newFilters)
        }}
      />
      <Input
        placeholder="user"
        className="w-[150px]"
        value={filters.user || ''}
        onChange={(e) => {
          const newFilters = { ...filters }
          if (e.target.value) {
            newFilters.user = e.target.value
          } else {
            delete newFilters.user
          }
          setFilter(newFilters)
        }}
      />
    </div>
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">地址管理</h1>
      <ManageTable fields={fields} collect="addresses" filters={filters} filter={filterUI} onResetFilters={handleResetFilters} />
    </div>
  )
}
